module.exports = __webpack_public_path__ + "static/img/5.7ab2f48.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/active/snail/fifth/mo/zh/5.png
// module id = q+Cd
// module chunks = 1 3